/**
 * Copyright Facebook Inc.
 *
 * Licensed under the Apache License, Version 2.0
 * http://www.apache.org/licenses/LICENSE-2.0
 */

define('utils/user_agent',[],function(){
  var _populated = false;
  var _ie, _firefox, _opera, _webkit, _chrome;
  var _osx, _windows, _linux, _android;
  var _win64;
  var _iphone, _ipad, _native;
  var _mobile;

  function _populate() {
    if (_populated) {
      return;
    }
    _populated = true;
    // To work around buggy JS libraries that can't handle multi-digit
    // version numbers, Opera 10's user agent string claims it's Opera
    var uas = navigator.userAgent;
    var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))/.exec(uas);
    var os    = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);

    _iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
    _ipad = /\b(iP[ao]d)/.exec(uas);
    _android = /Android/i.exec(uas);
    _native = /FBAN\/\w+;/i.exec(uas);
    _mobile = /Mobile/i.exec(uas);
  
    // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
    // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
    // Windows will send 'WOW64' instead.
    _win64 = !!(/Win64/.exec(uas));

    if (agent) {
      _ie = agent[1] ? parseFloat(agent[1]) : NaN;
    
      if (_ie && document.documentMode) {
        _ie = document.documentMode;
      }
      _firefox = agent[2] ? parseFloat(agent[2]) : NaN;
      _opera   = agent[3] ? parseFloat(agent[3]) : NaN;
      _webkit  = agent[4] ? parseFloat(agent[4]) : NaN;
      if (_webkit) {
      
        // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
      
        agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
        _chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
      } else {
        _chrome = NaN;
      }
    } else {
      _ie = _firefox = _opera = _chrome = _webkit = NaN;
    }

    if (os) {
      if (os[1]) {
        var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);
        _osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
      } else {
        _osx = false;
      }
      _windows = !!os[2];
      _linux   = !!os[3];
    } else {
      _osx = _windows = _linux = false;
    }
  }

  var UserAgent = {
    ie: function() {
      return _populate() || _ie;
    },
    ie64: function() {
      return UserAgent.ie() && _win64;
    },
    firefox: function() {
      return _populate() || _firefox;
    },
    opera: function() {
      return _populate() || _opera;
    },
    webkit: function() {
      return _populate() || _webkit;
    },
    safari: function() {
      return UserAgent.webkit();
    },
    chrome : function() {
      return _populate() || _chrome;
    },
    windows: function() {
      return _populate() || _windows;
    },
    osx: function() {
      return _populate() || _osx;
    },
    linux: function() {
      return _populate() || _linux;
    },
    iphone: function() {
      return _populate() || _iphone;
    },
    mobile: function() {
      return _populate() || (_iphone || _ipad || _android || _mobile);
    },
    nativeApp: function() {
      return _populate() || _native;
    },
    android: function() {
      return _populate() || _android;
    },
    ipad: function() {
      return _populate() || _ipad;
    }
  };
  return UserAgent;
});

